import { Injectable } from "@angular/core";
import { BehaviorSubject, distinctUntilChanged, Observable } from "rxjs";

interface RunWizard {
  shouldRunWizard: boolean;
  resetBalance: boolean;
}

@Injectable({
  providedIn: "root",
})
export class SideMenuService {
  private isGlossMenuOpenSubject$ = new BehaviorSubject<boolean>(false);
  isGlossMenuOpen$: Observable<boolean> = this.isGlossMenuOpenSubject$.pipe(distinctUntilChanged());

  private _shouldRunWizard: BehaviorSubject<RunWizard> = new BehaviorSubject({
    shouldRunWizard: false,
    resetBalance: false,
  });
  shouldRunWizard$ = this._shouldRunWizard.asObservable();

  get isGlossMenuOpen(): boolean {
    return this.isGlossMenuOpenSubject$.value;
  }

  setShouldRunWizard(shouldRunWizard: boolean, resetBalance: boolean) {
    this._shouldRunWizard.next({ shouldRunWizard: shouldRunWizard, resetBalance });
  }

  setGlossMenuOpenState(isOpen: boolean) {
    this.isGlossMenuOpenSubject$.next(isOpen);
  }

  loadSideMenu$(): Observable<any> {
    return this.isGlossMenuOpen$;
  }
}
